
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { OrderItemDTO } from "../order/OrderSlice";
import { GeneralV3Response, InterceptorOption, LoadingType } from "../../../types/CommonTypes";
import { addCreditMemoData,  getApplyInvDetailByPracticeAndProductId,  getCreditMemoDetailsByInvId, getInvoiceFromId, getInvoiceList, getShareInvoiceList, saveInvoice, updateInvoiceData, uploadInvoice, uploadInvoiceNotesData, getInvoiceNoteById ,getEditInvoiceDetailByInvId, deleteSpecificInvoiceAgencyById, getInvoiceByManufacturerIdAndPracticeId, createInvoiceService, getInvoiceAgencyByInvoiceId, previewInvoiceService, stripeCheckout, stripeCheckoutSessionExpire, updateInvoiceStatusData, UpdateInvoiceStatus, addLateFeeByInvoiceId, getInvoiceFromIdLoadingGifSkipped, bulkPaymentCheckout, fetchInvoicesByPractice, stripeOAuthConnect, getLateFeeHistoryByInvoiceId, fetchProductsWithOpenInvoicesByPractice} from "../../../service/InvoiceService";
import { useAppSelector } from "../redux-hooks";

//CS-1212 - Start
export type InvoiceNotes = {
  attachmentId: number;
  noteType: string;
  content?: string;
  attachment: string;
  documentName: string;
  fileType: string;
  xrefTable: string;
  xrefId: string;
  auditUserName?: string,
  auditTimestamp? : string,
  comments?: string, 
};

export type InvoiceNoteDetail = {
  noteId: number;
  xrefTable: string;
  xrefId: number;
  noteType: string;
  content?: string;
  attachementId: number;
  documentName: string;
  fileType: string;  
  auditUserName?: string,
  auditTimestamp? : string,
  comments?: string, 
};
//CS-1212 - End

export type SearchInvoiceInfo = {
  fromDate: string | undefined;
  toDate: string | undefined;
  agencyIds: number[] | [];
  serialNumber?: string | null;
  usageStatus?:string | undefined  ;
  patientIds:number[] | [];
  // ovrAgencyIds: number[] | [];
  // v3PayStatus: string[];
  // agyPayStatus: string[];
  // ovrAgyPayStatus: string[];
  mfgInvoiceNumber?: string | null;
  orderNumber?: string | null;
  mfgIds: number[];
  commPeriod?: string,
  comm?: string,
  practiceIds: number[] | [];
  invoiceStatus: string[];
  currentPage: number;
  itemsPerPage: number;
  checkBox?: { [key: string]: boolean | undefined };
  selectAllCheckBox?: boolean;
  invoiceId?: number;
  isDownload: boolean;
  excludePurchaseAndBill: boolean;
  alertInvoices?: boolean;
  v3CommStatus?: string;
  agencyCommStatus?: string;
  ovrCommStatus?: string;
  dateRange?: string;
  v3ReceivedDateRange?: string;
  v3ReceivedFromDate?: string;
  v3ReceivedToDate?: string;
  agencyPaidDateRange?: string;
  agencyPaidFromDate?: string;
  agencyPaidToDate?: string;
  ovrPaidDateRange?: string;
  ovrPaidFromDate?: string;
  ovrPaidToDate?: string;
  invoiceAgeMin?: string | number;
  invoiceAgeMax?: string | number;
  // CS-1765 - Optional productId for bulk payment product-based search
  productId?: number;
  productIds?: number[];
  purchaseAndBillFilter?: string;
  invoiceAging?: string[] | string; // string retained for stored-search compatibility
  // Optional Excel View paging. Existing callers omit these; backend must
  // ignore them unless both recordOffset and recordLimit are present so
  // Invoice List / Export / Commission search stay unchanged.
  recordOffset?: number;
  recordLimit?: number;
  includeInvoiceSummary?: boolean;
  /** Excel View only. When true, each invoice includes payments[] with commissions (same shape as getPaymentsByInvoiceId). */
  includePayments?: boolean;
  /**
   * Finance HQ sales sheet only. When true, each invoice includes Product Units / COGs /
   * Cost Breakdown fields (productUnits, cogsPerUnit, cogsTotal, cogsAmount,
   * shippingChargesActual, v3TotalCost). Invoice List and Commission Export omit this.
   */
  includeProfitDetail?: boolean;
  // Optional. Absent values must keep the existing invoice and commission search order.
  // invoiceLateDays is invoice-list only. Commission does not send it.
  sortBy?: "mfgInvoiceNumber" | "mfgInvoiceDate" | "invoiceDueDate" | "invoiceLateDays" | "manufacturerName" | "practiceName" | "orderNumber" | "invoiceAmount" | "remainingAmount" | "invoiceStatus";
  sortOrder?: "asc" | "desc";
};

export type SearchShareInvoiceInfo = {
  mfgInvoiceNumber?: string | null;
  mfgIds?: number[];
  practiceIds?: number[];
  // CS-1666 - Invoice age range filter support in Share Invoice search
  invoiceAgeMin?: string | number;
  invoiceAgeMax?: string | number;
};

export type CommissionInfo = {
  commissionAgencyType: "AGENCY" | "OVERRIDE" | "V3",
  commissionAmount: number,
  commissionComments: string,
  commissionDate: string,
  commissionDocumentId: string,
  commissionId: number,
  fileId: number
}

export type AgencyCommission = {
  commissionInfo: CommissionInfo[],
  remainingAmount: number,
  totalAmount: number,
  commissionRate: number
}

export type PaymentInfo = {
  fileId: number,
  paymentAmount: number,
  paymentComments: string,
  paymentDate: string,
  paymentDocumentId: number,
  paymentId: number,
  paymentStatus: string,
  paymentMethod?: string,
}

export type Payment = {
  paymentInfo: PaymentInfo[],
  remainingAmount: number,
  totalAmount: string,
}

export type InvoiceDetailDTO = {
  invoiceId: number,
  manufacturerId: number,
  productId: number,
  practiceId: number,
  mfgInvoiceNumber: string,
  patientName?: string, //CS-1676
  mfgName: string,
  productName: string,
  practiceName: string,
  agencyName: string | string[],
  agentNames: string[],
  orderItems: OrderItemDTO[],
  invoiceAmount: number;
  creditAmount: number;
  netCogsAmount: number;
  orderId: number;
  orderNumber: string;
  invoiceStatus: string;
  calculatedAmount: number | string;
  v3ProductCommissionId: number;
  agencyProductCommissionId: number;
  mfgInvoiceDate: string;
  invoiceDueDate: string;
  v3CommissionAmount: number | string;
  agencyCommissionAmount: number | string;
  ovrAgencyProductCommissionId: number;
  ovrAgencyCommissionAmount: number | string;
  invoiceDocumentId: number;
  v3AgencyId: number;
  overrideAgencyId: number;
  manufacturerName: string;
  v3InvoicePaidAmount: number | string;
  v3CommissionPaidAmount: number | string;
  agencyCommissionPaidAmount: number | string;
  ovrAgencyCommissionPaidAmount: number | string;
  v3CommNet: number | string;
  agencyId: number,
  agencyCommissions: AgencyCommission[],
  v3Commissions: AgencyCommission,
  ovrAgencyCommissions: AgencyCommission[],
  payment: Payment
  overrideAgencyName: string,
  shippingCharges: number,
  orderDocumentId: number,
  productCategory: string,
  orderDate?: string,
  dateOfService?: string,
  orderStatus?: string,
  poNumber?: string,
  providerName?: string,
  patientId?: number,
  shippingCarrier?: string,
  trackingNumber?: string,
  actualShippingMethod?: string,
  requestedShippingMethod?: string,
  manufacturerInactiveDate?: string,
  productInactiveDate?: string,
  purchaseAndBill?: string | null; // CS-1765
  //CS-1322 - Added mfrConfig 
  manufactureCustomConfig?:{
    purchase_and_bill?: string;
  }
  manufacturerStripeConfig?:{
    stripe_integration?: string; //CS-1563
  }
  fromNetsuiteWebhook?: boolean,
  outstandingAmt: number
  lateFee: number,
  invReferenceId?: string | null;
  invoiceLateDays?: number;
  paymentInstructionType: string;
  paymentInstructionValue: string;
  hasPaymentInstruction: Boolean;
  isUpfrontOrder?: Boolean;
  listSubtotal?: number;
  discountAmount?: number;
  discount?: number | null;
  platformFeeAmount?: number;
};

export type LateFeeHistoryDTO = {
  auditLogId: number;
  type: string;
  actionType: string;
  auditTimestamp: string;
  message: string;
  updatedBy: string;
};

export type AgyPayout = {
  invoices: { invoiceId: number, agencyId: number }[],
  commissionAgencyType: 'AGENCY' | 'OVERRIDE',
  payment: number,
  payoutDate: string,
  payoutComment: string
};

export type RecordPayoutOverrideInfo = {
  payment: string;
  payoutDate: string;
  payoutComment: string;
};

export type invoiceInfo = {
  invoiceId: number;
  orderId?: number;
  customConfig:{
    purchase_and_bill?: string;
  };
  stripeConfig:{
    stripe_integration?:string	//CS-1563
  }
  manufacturerId: number;
  mfgInvoiceNumber: string | any;
  mfgInvoiceNumberLink?: string | JSX.Element;//CS-1406 - rendering mfg invoice number with link
  invoiceStatus: string | any;
  customInvoiceStatus?: string | any;
  invoiceAmount: number | string;
  creditAmount: number | string; // CS-1745 - Added to support credit amount validation on invoice update
  calculatedAmount: number | string;
  v3ProductCommissionId: number;
  agencyProductCommissionId: number;
  mfgInvoiceDate: string;
  invoiceDueDate: string;
  v3CommissionAmount: number | string;
  agencyCommissionAmount: number | string;
  ovrAgencyProductCommissionId: number;
  ovrAgencyCommissionAmount: number | string;
  invoiceDocumentId: number;
  productId: number;
  practiceId: number;
  productName: string;
  v3AgencyId: number;
  overrideAgencyId: number;
  practiceName: string;
  manufacturerName: string;
  v3InvoicePaidAmount: number | string;
  v3CommissionPaidAmount: number | string;
  agencyCommissionPaidAmount: number | string;
  ovrAgencyCommissionPaidAmount: number | string;
  agencyCommissionRate: number | string;
  ovrAgencyCommissionRate: number | string;
  v3CommNet: number | string;
  orderItems: OrderItemDTO[];
  agencyId: number;
  invoiceLateDays?: any;
  orderNumber: string | any;
  raworderNumber?: string | any;
  overrideAgencyName: string;
  agencyName?: string;
  v3CommissionAmounts:number | string;
  agencyCommissionAmounts: number | string;
  ovrAgencyCommissionAmounts:number | string;
  remainingAmount?: number | string |JSX.Element;
  shippingCharges?: number;
  netInvoiceAmount?: number | string;
  outstandingAmount?: number | string; //CS-1458 - Change
  totalAgencyPaid?: number;
  totalOvrPaid?: number;
  totalV3Paid?: number;
  expectedV3Amt?: number;
  expectedAgencyAmt?: number;
  expectedOvrAmt?: number;
  lateFee?: number;
  invReferenceId?: string | null;
  purchaseAndBill?: string | null;
  paymentInstructionType?: string;
  paymentInstructionValue?: string;
  hasPaymentInstruction?: Boolean;
  isUpfrontOrder?:Boolean; //CS-1845
  productUnits?: number;
  cogsPerUnit?: number;
  cogsTotal?: number;
  gpAmount?: number;
  gpPerUnit?: number;
  gpPreCosAmount?: number;
  gpPreCosPerUnit?: number;
  fromNetsuiteWebhook?: boolean;
  agencyCommissions?: AgencyCommission[];
  v3Commissions?: AgencyCommission;
  ovrAgencyCommissions?: AgencyCommission[];
}
export type Attachment = {
  content: string,
  documentName: string,
  fileType: string,
  type: string
}

export type uploadInvoiceRequest = {
  content: string;
  documentName: string;
  fileType: string;
  type: string;
};

export interface SaveInvoiceInfo {
  orderId: number;
  manufacturerId: number;
  mfgInvoiceNumber: string;
  mfgInvoiceDate?: string;
  invoiceDueDate?: string;
  calculatedAmount: number;
  invoiceAmount: number;
  orderItems: { orderItemId: number }[];
  attachInvoice?: Attachment[];
  orderInvoiceStatus: "INVOICED" | "PARTIAL";
}
//CS-1322 - Start
export interface CreateInvoiceInfo {
  orderId: number;
  manufacturerId: number;
  mfgInvoiceDate?: string;
  invoiceDueDate?: string;
  comments?: string;
  calculatedAmount: number;
  shippingCharges: number;
  lateFee: number;
  invoiceAmount: number;
  orderItems: { orderItemId: number }[];
  orderInvoiceStatus: "INVOICED" | "PARTIAL";
}
//CS-1322 - End

// task cs-647 start
export interface UpdateInvoice {
  invoiceId:number;
  mfgInvoiceNumber: number;
  mfgInvoiceDate: string;
  invoiceDueDate:string;
  invoiceAmount: number ;
  v3CommissionAmounts:number;
  v3CommissionAmount: number ;
  agencyCommissionAmounts:number;
  agencyCommissionAmount: number ;
  ovrAgencyCommissionAmounts:number;
  ovrAgencyCommissionAmount: number;
  agencyId:number;
  ovrAgencyId: number;
  invoiceStatus:string;
  productName:string;
}
// task cs-647 end

export interface PaginationInvoiceList {
  content: invoiceInfo[];
  totalElements: number;
  totalPages: number;
  size: number;
}

export interface creditMemoInvoiceData {
  dateOfCredit: string;
  invoiceId: number;
  remainingAmount: number;
  mfgInvoiceNumber: string;
  orderNumber: string;
  productReturnDTOList: any;
  creditMemoDTOList: any;
}

//CS-1191 - Start
export interface CommissionDetail{
  productCommissionId: number;
  productId: number;
  agencyId: number;
  agencyName: string;
  associateAgencyId: number | null;
  associateAgencyName: string | null;
  commissionRate: number;
  commissionPayTerms: string;
  effectiveDate: string;
  inactiveDate: string | null;
  associatePracticeId: number | null;
  associatePracticeName: string | null;
  associateAccountRepId: number | null;
  associateAccountRepName: string | null;
  associateType: string | null;
  agencyType: string;
}
export interface ApplyInvDetail {
  commissionDetail: CommissionDetail[] ;
}
export interface EditInvDetail {
  invoiceId: number;
  productId: number;
  productName: string;
  practiceId: number;
  practiceName: string;
  manufacturerId: number;
  mfgName: string;
  mfgInvoiceNumber: string;
  calculatedAmount: number;
  invoiceAmount: number;
  mfgInvoiceDate: string;
  invoiceDueDate: string; 
  orderId: number;
  orderNumber: string;
  patientId: number;
  patientName: string;
  shippingCharge: number;
  lateFee: number;
  invReferenceId?: string | null;
  comments: string;
  invoiceCommissionDetailsList:CommissionDetail[] | null;
  documentDto:{
    content:any;
    documentName:any;
    type:any;
    fileType:any;
    documentId:any;
  }|null;
  purchaseAndBill?: string | null; // CS-1765
  manufactureCustomConfig:{
    invoice_due_date:string|null;
    invoice_net_days:number|null;
    cc_authorized_practice_user:string|null;
    purchase_and_bill:string|null;
  };
  creditAmount?: number | string;
  payment:{
    paymentInfo:[]|null;
    remainingAmount: number | string;
    totalAmount: string | number;
  }
  orderItemDTOList:[]|null
}

export type invoiceAgencyInfo = {
  invoiceAgencyId: number;
  invoiceId: number;
  agencyId: number;
  agencyType: string;
  productCommissionId: number;
  expectedCommissionRate: number;
  expectedCommissionAmount: number;
  commissionChangeForAllFutureInvoices: boolean;
  auditUserId: number;
  auditTimestamp: string;
  agencyName?: string;
  invoiceNumber?: string;
  auditUserName?: string;
};


//CS-1191 - End
type InvoiceState = {
  invoice?: UpdateInvoice | null; //add this task cs-647
  invoiceList: PaginationInvoiceList | null;
  invoiceListFetchStatus?: LoadingType;
  invoiceSaveStatus?: LoadingType;
  updateinvoicestatus?:LoadingType;
  getInvoiceByIdStatus?: LoadingType;
  uploadInvoiceRequest: PaymentRequest | null;
  invoiceUploadStatus?: LoadingType;
  recordCreditMemo?:creditMemoInvoiceData|null;
  invoiceNotesList?:InvoiceNoteDetail[]; //CS-1212
  invoiceNotesUploadStatus?: LoadingType; //CS-1212
  invoiceNotesFetchStatus?: LoadingType; //CS-1212
  applyInvDetail?:{
    commissionDetail: CommissionDetail[];
  } ; // CS-1191
  editInvoiceDetail:EditInvDetail | null,
  getApplyInvDetailByIdStatus?: LoadingType; // CS-1191
  invoicesByManufacturerAndPractice?:invoiceInfo[] // CS - 1216
  getInvoiceByManufacturerIdStatus?: LoadingType; // CS - 1216
  getEditInvDetailByIdStatus?: LoadingType; // CS-1191
  getInvoiceAgencyStatus?: LoadingType; // CS-1384
  invoiceAgencyList?:invoiceAgencyInfo[];
  invoiceObject?: InvoiceDetailDTO;
  // Bulk payment state
  bulkPaymentInvoiceList: invoiceInfo[];
  bulkPaymentInvoiceListFetchStatus?: LoadingType;
  // CS-1995 - products with open (PARTIAL/UNPAID) invoices for the selected practice (bulk payment product dropdown)
  bulkPaymentProducts: BulkPaymentProductInfo[];
  bulkPaymentProductsFetchStatus?: LoadingType;
  // CS-1750 - Start
  stripeOAuthConnectStatus?: LoadingType;
  // CS-1750 - End
  lateFeeHistory?: LateFeeHistoryDTO[];
  lateFeeHistoryFetchStatus?: LoadingType;
}

const initialState: InvoiceState = {

  invoice: {        //add this task cs-647
    invoiceId:0,
    mfgInvoiceNumber: 0,
    mfgInvoiceDate: "", 
    invoiceDueDate:"",     
    invoiceAmount: 0,
    v3CommissionAmounts:0,
    v3CommissionAmount: 0,
    agencyCommissionAmounts:0,
    agencyCommissionAmount: 0,
    ovrAgencyCommissionAmounts:0,
    ovrAgencyCommissionAmount: 0,
    invoiceStatus:"",
    agencyId:0,
    ovrAgencyId:0,
    productName:"",
  },
  invoiceList: null,
  uploadInvoiceRequest: null,
  invoiceListFetchStatus: 'idle',
  invoiceSaveStatus: 'idle',
  getInvoiceByIdStatus: 'idle',
  invoiceUploadStatus: "idle",
  editInvoiceDetail: {
    invoiceId: 0,
    productId: 0,
    productName: "",
    practiceId: 0,
    practiceName: "",
    manufacturerId: 0,
    mfgName: "",
    mfgInvoiceNumber: "",
    calculatedAmount: 0,
    invoiceAmount: 0,
    mfgInvoiceDate: "",
    invoiceDueDate: "",
    orderId: 0,
    orderNumber: "",
    patientId: 0,
    patientName: "",
    shippingCharge: 0,
    lateFee: 0,
    comments: "", 
    purchaseAndBill: null, // CS-1765
    invoiceCommissionDetailsList:null,
    orderItemDTOList: [],
    documentDto:null,
    manufactureCustomConfig:{
    invoice_due_date:null,
    invoice_net_days:null,
    cc_authorized_practice_user:null,
    purchase_and_bill:null,
  },
    payment: {
      paymentInfo: null,
      remainingAmount: 0,
      totalAmount: 0
    }
  },
  invoiceNotesList: [], //CS-1212
  invoiceNotesUploadStatus: "idle", //CS-1212
  invoiceNotesFetchStatus: "idle", //CS-1212
  applyInvDetail: {
    commissionDetail: [], // CS-1191
  }, // CS-1191
  getApplyInvDetailByIdStatus: 'idle', // CS-1191
  invoicesByManufacturerAndPractice: [], // CS - 1216
  getInvoiceByManufacturerIdStatus: 'idle', // CS - 1216
  getEditInvDetailByIdStatus: 'idle', // CS-1191
  bulkPaymentInvoiceList: [],
  bulkPaymentInvoiceListFetchStatus: 'idle',
  // CS-1995 - bulk payment product dropdown
  bulkPaymentProducts: [],
  bulkPaymentProductsFetchStatus: 'idle',
  // CS-1750 - Start
  stripeOAuthConnectStatus: 'idle',
  // CS-1750 - End
  lateFeeHistory: [],
  lateFeeHistoryFetchStatus: 'idle',
}

export const fetchInvoiceList = createAsyncThunk("fetchInvoiceList", async (data: SearchInvoiceInfo) => {
  
  const response = await getInvoiceList(data);
  const v3Response = response.data;
  return v3Response;
});

// Bulk payment invoice list fetch
export const fetchBulkPaymentInvoiceList = createAsyncThunk("fetchBulkPaymentInvoiceList", async (data: SearchInvoiceInfo) => {
  const response = await getInvoiceList(data);
  const v3Response = response.data;
  return v3Response;
});

// CS-1995 - bulk payment product dropdown: products with open (PARTIAL/UNPAID) invoices for a practice (Stripe-enabled MFR)
export type BulkPaymentProductInfo = {
  productId: number;
  productName: string;
  manufacturerId: number;
  manufacturerName: string;
};

export const fetchBulkPaymentProducts = createAsyncThunk("fetchBulkPaymentProducts", async (practiceId: number) => {
  const response = await fetchProductsWithOpenInvoicesByPractice(practiceId);
  const v3Response = response.data;
  return v3Response;
});

export const fetchShareInvoiceList = createAsyncThunk("fetchShareInvoiceList", async (data: SearchShareInvoiceInfo) => {
  const response = await getShareInvoiceList(data);
  const v3Response = response.data;
  return v3Response;
});

export const getInvoiceById = createAsyncThunk("getInvoiceById", async ({invoiceId, isSaveAuditLog, skipLoader = false,}: {invoiceId: number; isSaveAuditLog: boolean; skipLoader?: boolean;}) => {
    const response = await getInvoiceFromId({ invoiceId, isSaveAuditLog, skipLoader });
  const v3Response = response.data;
  return v3Response;
});

export const getInvoiceByIdLoadingGifSkipped = createAsyncThunk<any, {invoiceId: number, isSaveAuditLog: boolean, skipLoader?:boolean}>("getInvoiceByIdLoadingGifSkipped", async ({invoiceId, isSaveAuditLog, skipLoader= false}) => {
  const response = await getInvoiceFromIdLoadingGifSkipped(invoiceId, isSaveAuditLog, { 'x-skip-loader': skipLoader.toString() });
  const v3Response = response.data;
  return v3Response;
});

//task cs-647 start
export const updateInvoice = createAsyncThunk<any, { data: UpdateInvoice, interceptorOption: InterceptorOption }>(
  "updateInvoice",
  async (data, { rejectWithValue }) => {
    const { data: invoiceData, interceptorOption } = data;
    try {
      const response = await updateInvoiceData(invoiceData, interceptorOption);
      return response.data;
    } catch (error) {
      //@ts-ignore
      return rejectWithValue(error?.data);
    }
  }
);

//task cs-647 end

// CS-1532 - Start
export const changeInvoiceStatus = createAsyncThunk<any, { data: UpdateInvoiceStatus, interceptorOption: InterceptorOption }>(
  "changeInvoiceStatus",
  async (data, { rejectWithValue }) => {
    const { data: invoiceStatusData, interceptorOption } = data;
    try {
      const response = await updateInvoiceStatusData(invoiceStatusData, interceptorOption);
      return response.data;
    } catch (error) {
      //@ts-ignore
      return rejectWithValue(error?.data);
    }
  }
);
// CS-1532 - End



export const addInvoice = createAsyncThunk<any, { invoiceData: SaveInvoiceInfo, interceptorOption: InterceptorOption }>("addInvoice", async (data, { rejectWithValue }) => {
  const { invoiceData, interceptorOption } = data
  try {
    const response = await saveInvoice(invoiceData, interceptorOption);
    const v3Response = response.data;
    return v3Response;
  } catch (error) {
    //@ts-ignore
    return rejectWithValue(error?.data);
  }
});

//CS-1322 - Start
export const createInvoice = createAsyncThunk<any, { invoiceData: CreateInvoiceInfo, interceptorOption: InterceptorOption }>("createInvoice", async (data, { rejectWithValue }) => {
  const { invoiceData, interceptorOption } = data
  try {
    const response = await createInvoiceService(invoiceData, interceptorOption);
    const v3Response = response.data;
    return v3Response;
  } catch (error) {
    //@ts-ignore
    return rejectWithValue(error?.data);
  }
})
export const previewInvoice = createAsyncThunk<any, { invoiceId: number, interceptorOption: InterceptorOption }>("previewInvoice", async (data, { rejectWithValue }) => {
  const { invoiceId, interceptorOption } = data
  try {
    const response = await previewInvoiceService(invoiceId, interceptorOption);
    const v3Response = response.data;
    return v3Response;
  } catch (error) {
    //@ts-ignore
    return rejectWithValue(error?.data);
  }
})
//

export const uploadInvoices = createAsyncThunk<any, { invoiceData: any, interceptorOption?: InterceptorOption }>(
  "uploadInvoice",
  async (data, { rejectWithValue }) => {
    try {
      const { invoiceData, interceptorOption } = data
      const response = await uploadInvoice(invoiceData, interceptorOption);
      return response;
    } catch (error) {
      //@ts-ignore
      return rejectWithValue(error?.data)
    }
  }
);
export const getCreditMemoDetailsById = createAsyncThunk("getCreditMemoDetailsById", async (id: number) => {
  const response = await getCreditMemoDetailsByInvId(id);
  const v3Response = response.data;
  return v3Response;
});

export const addCreditMemo = createAsyncThunk("addCreditMemo",async(data:any)=>{
  const response = await addCreditMemoData(data);
  const v3Response = response.data;
  return v3Response;

})

//CS-1212 - Start
export const uploadInvoiceNotes = createAsyncThunk(
  "uploadInvoiceNotes",
  async (data: any) => {
    const response = await uploadInvoiceNotesData(data);
    return response.data;
  }
);
//CS-1212 - End

//CS-1191 - Start
export const getApplyInvDetailById = createAsyncThunk("getApplyInvDetailById", async({ practiceId, productId }: { practiceId: string | number; productId: string | number }) => {
  const data = {
    practiceId: practiceId, 
    productId: productId
  };
  const response = await getApplyInvDetailByPracticeAndProductId(data)
  const v3Response = response.data;
  return v3Response;
});
export const getEditInvDetailsById = createAsyncThunk("getEditInvDetailsById",  async (invId: number) => {
  // CS-1765 - Edit invoice response now includes purchaseAndBill at top level
  const response = await getEditInvoiceDetailByInvId(invId)
  const v3Response = response.data;
  return v3Response;
});
export const deleteInvSpecificAgencyByInvAgencyId = createAsyncThunk("deleteInvSpecificAgencyByInvAgencyId",  async (id: number) => {
  const response = await deleteSpecificInvoiceAgencyById(id)
  const v3Response = response.data;
  return v3Response;
});
//CS-1191 - End

//CS-1212 - Start
export const fetchInvoiceNotesById = createAsyncThunk("fetchInvoiceNotesById", async (xrefTable: number) => {
  const response = await getInvoiceNoteById(xrefTable, 'INVOICE');
  const v3Response = response.data;
  return v3Response;
});
//CS-1212 - End

// CS - 1216 Start
export const getInvoiceByManufacturerAndPractice = createAsyncThunk<any, { manufacturerId: number, practiceId: number, skipLoader?: boolean }>("getInvoiceByManufacturerAndPractice", async ({ manufacturerId, practiceId, skipLoader = false }) => {
    const data = {
    practiceId: practiceId,
    manufacturerId: manufacturerId
  };
  const response = await getInvoiceByManufacturerIdAndPracticeId(data, { 'x-skip-loader': skipLoader.toString() });
  const v3Response = response.data;
  return v3Response;
});
// CS - 1216 End
// export const genrateStripeAccountKeyData = createAsyncThunk("genrateStripeAccountKey", async (data: any) => {
//   try {
//     const response = await genrateStripeAccountKey(data);
//     return response.data;
//   } catch (error) {
//     //@ts-ignore
//     return rejectWithValue(error?.data);
//   }
// });
export const stripeCheckOutPaymentData = createAsyncThunk("stripeCheckOutPaymentData", async (data: any) => {
  try {
    const skipLoader = !!data?.skipLoader;
    const payload = skipLoader
      ? (({ skipLoader: _skip, ...rest }) => rest)(data)
      : data;
    const response = skipLoader
      ? await stripeCheckout(payload, true)
      : await stripeCheckout(data);
    return response.data;
  } catch (error) {
    //@ts-ignore
    return rejectWithValue(error?.data);
  }
});

//CS-1682 - Bulk Payment Checkout
export const bulkPaymentCheckoutData = createAsyncThunk("bulkPaymentCheckoutData", async (data: any) => {
  try {
    const response = await bulkPaymentCheckout(data);
    return response.data;
  } catch (error) {
    //@ts-ignore
    return rejectWithValue(error?.data);
  }
});

export const expireStripeCheckoutSession = createAsyncThunk("expireStripeCheckoutSession", async (data: any) => {
  try {
    const response = await stripeCheckoutSessionExpire(data);
    return response.data;
  } catch (error) {
    //@ts-ignore
    return rejectWithValue(error?.data);
  }
});

//CS-1384 - Start
export const fetchInvoiceAgency = createAsyncThunk(
  "fetchInvoiceAgency",
  async (arg: number | { invoiceId: number; skipLoader?: boolean }) => {
    const invoiceId = typeof arg === "number" ? arg : arg.invoiceId;
    const skipLoader = typeof arg === "object" && arg !== null && !!arg.skipLoader;
    const response = skipLoader
      ? await getInvoiceAgencyByInvoiceId(invoiceId, true)
      : await getInvoiceAgencyByInvoiceId(invoiceId);
    const v3Response = response.data;
    console.log(v3Response)
    return v3Response;
  }
);
//CS-1384 - End

// CS-1583 - START
export const addLateFeeByInvoice = createAsyncThunk<any, { invoiceId: string | number; lateFee: string | number, skipLoader?: boolean }>("addLateFeeByInvoice", async ({ invoiceId, lateFee, skipLoader = false }) => {
  const response = await addLateFeeByInvoiceId(invoiceId, lateFee, { 'x-skip-loader': skipLoader.toString() })
  const v3Response = response.data;
  return v3Response;
});
// CS-1583 - END

export const getInvoicesByPractice = createAsyncThunk<any, { practiceId: number }>(
  "getInvoicesByPractice",
  async (data, { rejectWithValue }) => {
    try {
      const { practiceId } = data;
      const response = await fetchInvoicesByPractice(practiceId);
      return response.data;
    } catch (error) {
      //@ts-ignore
      return rejectWithValue(error?.data);
    }
  }
);

export const fetchLateFeeHistory = createAsyncThunk("fetchLateFeeHistory", async (invoiceId: number) => {
  const response = await getLateFeeHistoryByInvoiceId(invoiceId);
  const v3Response = response.data;
  return v3Response;
});

// CS-1750 - Start
export const stripeOAuthConnectData = createAsyncThunk<any, { code: string }>(
  "stripeOAuthConnectData",
  async (data, { rejectWithValue }) => {
    try {
      const response = await stripeOAuthConnect(data.code);
      return response.data;
    } catch (error) {
      //@ts-ignore
      return rejectWithValue(error?.data);
    }
  }
);
// CS-1750 - End

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {

    updateInvoiceInfoObject: (state: InvoiceState, action) => {
      state.invoice = action.payload;
    },
    clearInvoiceObject: (state: InvoiceState) => {
      state.invoice = null;
    },
    // CS - 1216 Start
    resetInvoicesByManufacturerAndPractice: (state: InvoiceState) => {
      state.invoicesByManufacturerAndPractice = []
    },
    // CS - 1216 End
    resetinvoiceAgencyList: (state: InvoiceState) => {
      state.invoiceAgencyList = []
    },
    resetInvoiceList: (state: InvoiceState) => {
      state.invoiceList = null
    },
    resetEditInvoiceDetails: (state: InvoiceState) => {
      state.editInvoiceDetail = null;
    },
    // Clear bulk payment state
    clearBulkPaymentInvoiceList: (state: InvoiceState) => {
      state.bulkPaymentInvoiceList = [];
      state.bulkPaymentInvoiceListFetchStatus = 'idle';
    },
    // CS-1995 - clear bulk payment product dropdown state
    clearBulkPaymentProducts: (state: InvoiceState) => {
      state.bulkPaymentProducts = [];
      state.bulkPaymentProductsFetchStatus = 'idle';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoiceList.pending, (state) => {
        state.invoiceListFetchStatus = "loading";
      })
      .addCase(fetchInvoiceList.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.invoiceListFetchStatus = "success";
        // state.invoiceList = action.payload.data;
        state.invoiceList = action.payload?.data; // CS-1984
      })
      .addCase(fetchInvoiceList.rejected, (state, action) => {
        state.invoiceListFetchStatus = 'error';
      })
      .addCase(addInvoice.pending, (state) => {
        state.invoiceSaveStatus = "loading";
      })
      .addCase(addInvoice.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.invoiceSaveStatus = "success";
      })
      .addCase(addInvoice.rejected, (state, action) => {
        state.invoiceSaveStatus = 'error';
      })
      .addCase(updateInvoice.fulfilled, (state, action) => {
          state.updateinvoicestatus = "success"     //add task for cs-647
        // state.invoice = action.payload.data
        state.invoice = action.payload?.data // CS-1984
      })
      .addCase(changeInvoiceStatus.pending, (state) => {
        state.updateinvoicestatus = "loading";
      })
      .addCase(changeInvoiceStatus.fulfilled, (state, action) => {
        state.updateinvoicestatus = "success";
      })
      .addCase(changeInvoiceStatus.rejected, (state) => {
        state.updateinvoicestatus = "error";
      })
      .addCase(getInvoiceById.pending, (state) => {
        state.getInvoiceByIdStatus = "loading";
      })
      .addCase(getInvoiceById.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.getInvoiceByIdStatus = "success";
        // state.invoiceObject = action.payload.data
        state.invoiceObject = action.payload?.data // CS-1984
      })
      .addCase(getInvoiceById.rejected, (state, action) => {
        state.getInvoiceByIdStatus = 'error';
      })
      .addCase(getInvoiceByIdLoadingGifSkipped.pending, (state) => {
        state.getInvoiceByIdStatus = "loading";
      })
      .addCase(getInvoiceByIdLoadingGifSkipped.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.getInvoiceByIdStatus = "success";
        state.invoiceObject = action.payload.data
      })
      .addCase(getInvoiceByIdLoadingGifSkipped.rejected, (state, action) => {
        state.getInvoiceByIdStatus = 'error';
      })
      .addCase(uploadInvoices.pending, (state) => {
        state.invoiceUploadStatus = "loading";
      })
      .addCase(uploadInvoices.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.invoiceUploadStatus = "success";
      })
      .addCase(uploadInvoices.rejected, (state, action) => {
        state.invoiceUploadStatus = 'error';
      })
      .addCase(getCreditMemoDetailsById.pending, (state) => {
        state.invoiceUploadStatus = "loading";
      })
      .addCase(getCreditMemoDetailsById.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.invoiceUploadStatus = "success";
        state.recordCreditMemo = action.payload.data;
      })
      .addCase(getCreditMemoDetailsById.rejected, (state, action) => {
        state.invoiceUploadStatus = 'error';
      })
      //CS-1212 - Start
      .addCase(uploadInvoiceNotes.pending, (state) => {
        state.invoiceNotesUploadStatus = "loading";
      })
      .addCase(
        uploadInvoiceNotes.fulfilled,
        (state, action: PayloadAction<GeneralV3Response>) => {
          state.invoiceNotesUploadStatus = "success";
        }
      )
      .addCase(uploadInvoiceNotes.rejected, (state, action) => {
        state.invoiceNotesUploadStatus = "error";
      })
      .addCase(fetchInvoiceNotesById.pending, (state) => {
        state.invoiceNotesFetchStatus = "loading";
      })
      .addCase(
        fetchInvoiceNotesById.fulfilled,
        (state, action: PayloadAction<GeneralV3Response>) => {
          state.invoiceNotesFetchStatus = "success";
          // state.invoiceNotesList = action.payload.data; // CS-1984: guarded below
          state.invoiceNotesList = action.payload?.data || []; // CS-1984
        }
      )
      .addCase(fetchInvoiceNotesById.rejected, (state, action) => {
        state.invoiceNotesFetchStatus = "error";
      })
      //CS-1212 - End
      .addCase(getApplyInvDetailById.pending, (state) => {
        state.getApplyInvDetailByIdStatus = "loading";
      })
      .addCase(getApplyInvDetailById.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {  
        state.getApplyInvDetailByIdStatus = "success";
        state.applyInvDetail = action.payload.data;
      })
      .addCase(getApplyInvDetailById.rejected, (state, action) => {
        state.getApplyInvDetailByIdStatus = 'error';
      })
      // CS - 1216 Start
      .addCase(getInvoiceByManufacturerAndPractice.pending, (state) => {
        state.getInvoiceByManufacturerIdStatus = "loading";
      })
      .addCase(getInvoiceByManufacturerAndPractice.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.getInvoiceByManufacturerIdStatus = "success";
        // state.invoicesByManufacturerAndPractice = action.payload.data; // CS-1984: guarded below
        state.invoicesByManufacturerAndPractice = action.payload?.data || []; // CS-1984
      })
      .addCase(getInvoiceByManufacturerAndPractice.rejected, (state, action) => {
        state.getInvoiceByManufacturerIdStatus = 'error';
      })
      // CS - 1216 End
      .addCase(getEditInvDetailsById.pending, (state) => {
        state.getEditInvDetailByIdStatus = "loading";
      })
      .addCase(getEditInvDetailsById.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {  
        state.getEditInvDetailByIdStatus = "success";
        // CS-1765 - Preserve top-level purchaseAndBill from edit invoice response
        state.editInvoiceDetail = action.payload.data;
      })
      .addCase(getEditInvDetailsById.rejected, (state, action) => {
        state.getEditInvDetailByIdStatus = 'error';
      })
      .addCase(fetchInvoiceAgency.pending, (state) => {
        state.getInvoiceAgencyStatus = "loading";
      })
      .addCase(fetchInvoiceAgency.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.getInvoiceAgencyStatus = "success";
        // state.invoiceAgencyList = action.payload.data; // CS-1984: guarded below
        state.invoiceAgencyList = action.payload?.data || []; // CS-1984
      })
      .addCase(fetchInvoiceAgency.rejected, (state, action) => {
        state.getInvoiceAgencyStatus = 'error';
      })
      // Bulk payment invoice list
      .addCase(fetchBulkPaymentInvoiceList.pending, (state) => {
        state.bulkPaymentInvoiceListFetchStatus = "loading";
      })
      .addCase(fetchBulkPaymentInvoiceList.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.bulkPaymentInvoiceListFetchStatus = "success";
        state.bulkPaymentInvoiceList = action.payload.data?.content || [];
      })
      .addCase(fetchShareInvoiceList.pending, (state) => {
        state.bulkPaymentInvoiceListFetchStatus = "loading";
      })
      .addCase(fetchShareInvoiceList.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.bulkPaymentInvoiceListFetchStatus = "success";
        state.bulkPaymentInvoiceList = Array.isArray(action.payload.data) ? action.payload.data : (action.payload.data?.content || []);
      })
      .addCase(fetchShareInvoiceList.rejected, (state) => {
        state.bulkPaymentInvoiceListFetchStatus = "error";
      })
      .addCase(fetchBulkPaymentInvoiceList.rejected, (state, action) => {
        state.bulkPaymentInvoiceListFetchStatus = 'error';
      })
      // CS-1995 - bulk payment product dropdown
      .addCase(fetchBulkPaymentProducts.pending, (state) => {
        state.bulkPaymentProductsFetchStatus = "loading";
        state.bulkPaymentProducts = [];
      })
      .addCase(fetchBulkPaymentProducts.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.bulkPaymentProductsFetchStatus = "success";
        // state.bulkPaymentProducts = Array.isArray(action.payload.data) ? action.payload.data : [];
        state.bulkPaymentProducts = Array.isArray(action.payload?.data) ? action.payload?.data : []; // CS-1984
      })
      .addCase(fetchBulkPaymentProducts.rejected, (state) => {
        state.bulkPaymentProductsFetchStatus = "error";
        state.bulkPaymentProducts = [];
      })
      // CS-1750 - Start
      .addCase(stripeOAuthConnectData.pending, (state) => {
        state.stripeOAuthConnectStatus = "loading";
      })
      .addCase(stripeOAuthConnectData.fulfilled, (state) => {
        state.stripeOAuthConnectStatus = "success";
      })
      .addCase(stripeOAuthConnectData.rejected, (state) => {
        state.stripeOAuthConnectStatus = "error";
      })
      // CS-1750 - End
      .addCase(fetchLateFeeHistory.pending, (state) => {
        state.lateFeeHistoryFetchStatus = "loading";
      })
      .addCase(fetchLateFeeHistory.fulfilled, (state, action: PayloadAction<GeneralV3Response>) => {
        state.lateFeeHistoryFetchStatus = "success";
        state.lateFeeHistory = action.payload.data ?? [];
      })
      .addCase(fetchLateFeeHistory.rejected, (state) => {
        state.lateFeeHistoryFetchStatus = "error";
      })
  }
});
export const { updateInvoiceInfoObject, clearInvoiceObject, resetInvoicesByManufacturerAndPractice, resetinvoiceAgencyList, resetInvoiceList, resetEditInvoiceDetails, clearBulkPaymentInvoiceList, clearBulkPaymentProducts } = invoiceSlice.actions;
export const useInvoiceSlice = () => useAppSelector((state) => state.invoiceSlice)

export default invoiceSlice.reducer; 
